import styled from 'styled-components';

export const StyledCaseStudyItem = styled.div`
    margin-bottom: 0.2rem;
`;

export const Image = styled.img<{ $type: string }>`
    @media (min-width: 768px) {
        max-height: ${({ $type }) => ($type === 'default' ? '215px' : 'auto')};
    }
    @media (max-width: 768px) {
        width: 100%;
    }
`;

export const CaseStudyTitle = styled.p`
    margin: 0;
    font-size: 1rem;
    font-style: italic;
    font-weight: 500;
    line-height: 1.5625rem;
    margin-top: 1.2rem;
    margin-bottom: 1.2rem;
    min-height: 75px;
`;

export const CaseStudyLink = styled.a`
    color: black;
    font-size: 0.9375rem;
    font-style: normal;
    font-weight: 700;
    line-height: 1.25rem;
    display: flex;

    &:hover {
        text-decoration: none;
    }
`;

export const Arrow = styled.img`
    margin: 0 !important;
    margin-left: 5px !important;
    width: 10px !important;
    height: 10px !important;
`;
